import { render, staticRenderFns } from "./logo-upload-control.vue?vue&type=template&id=d40c71cc&"
import script from "./logo-upload-control.vue?vue&type=script&lang=js&"
export * from "./logo-upload-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports